import { render, staticRenderFns } from "./WardrobeDoorsNumber.vue?vue&type=template&id=1faeb56e&"
import script from "./WardrobeDoorsNumber.vue?vue&type=script&lang=js&"
export * from "./WardrobeDoorsNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports